import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Paper, Text, Loader, Alert, Button } from "@mantine/core";
import { FamilyDetails } from "./FamilyDetails";
import { api, type FamilyWithGuests } from "../services/api";

type Family = FamilyWithGuests;

export function FamilyByLink() {
  const { link } = useParams<{ link: string }>();
  const [family, setFamily] = useState<Family | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadFamily();
  }, [link]);

  const loadFamily = async () => {
    if (!link) {
      setError("No family link provided");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const familyData = await api.getFamilyByLink(link);
      setFamily(familyData);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load family details");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <Paper p="xl" shadow="sm" style={{ textAlign: "center" }}>
        <Loader size="lg" />
        <Text style={{ marginTop: "1rem" }}>Recherche des détails...</Text>
      </Paper>
    );
  }

  if (error || !family) {
    return (
      <Paper p="xl" shadow="sm">
        <Alert color="red" title="Error" style={{ marginBottom: "1rem" }}>
          {error || "Family not found"}
        </Alert>
        <Text size="sm" c="dimmed" style={{ marginBottom: "1rem" }}>
          Le lien du clan que vous essayez d'accéder n'existe pas ou a pu être modifié.
        </Text>
        <Button component="a" href="/">
          Retour à la recherche
        </Button>
      </Paper>
    );
  }

  return <FamilyDetails familyId={family.id} onBack={() => window.location.href = "/"} />;
}
